import request from '@/utils/request'

// 사용자가 선택 가능한 일반 요금제 조회
export function getNormalFeeList (params, isNotify) {
  return request({
    url: `/api/getNormalFeeList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 사용자가 선택 가능한 정액 요금제 조회
export function getMonthlyFeeList (params, isNotify) {
  return request({
    url: `/api/getMonthlyFeeList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 사용자가 업그레이드 가능한 정액 요금제 조회
export function getMonthlyFeeUpgradeList (params, isNotify) {
  return request({
    url: `/api/getMonthlyFeeUpgradeList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 사용자가 사용중인 정액 요금제 및 자동 결제 정보
export function getActiveMonthlyFee (params, isNotify) {
  return request({
    url: `/api/getActiveMonthlyFee`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 고객사의 정액 요금제를 사용중인 사업장(공사) 조회
export function getActiveMonthlyCompList (params, isNotify) {
  return request({
    url: `/api/getActiveMonthlyCompList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}